import Flickity from "flickity"
require("flickity-as-nav-for")

const Home = () => {
  const contentSlideEl = document.querySelector(".slider-content .slides")
  const mediaSlideEl = document.querySelector(".slider-media .slides")

  let autoPlay = 5000

  if (IS_DEV) {
    autoPlay = false
  }

  if (mediaSlideEl) {
    const mediaSlideFlkty = new Flickity(mediaSlideEl, {
      pageDots: false,
      wrapAround: true,
      prevNextButtons: false,
      draggable: window.screen.width <= 576,
      asNavFor: contentSlideEl
    })
  }

  if (contentSlideEl) {
    const contentSlideFlkty = new Flickity(contentSlideEl, {
      cellAlign: "left",
      prevNextButtons: false,
      wrapAround: true,
      autoPlay
    })
  }
}

export { Home }
